import Link from 'next/link';

import { Box, Container, Flex, Heading, IconButton } from '@chakra-ui/react';

import { Logo } from '@nocowanie/common-ui';
import { IconsLinear } from '@nocowanie/icons';

import { commonUiStateSlice, useAppSelector } from '@app/state';

import { CheckoutNavbarProps } from './checkout-navbar.props';
import { defaultCheckoutNavbarTranslation } from './checkout-navbar.translation.model';

export const CheckoutNavbar = ({
    infoTextInsteadOfLogoOnMobile,
    showBackButton = false,
    translationData = defaultCheckoutNavbarTranslation,
    backButtonProps = {},
    headingProps = {},
    children,
    ...rest
}: CheckoutNavbarProps) => {
    const { href, asLink: backButtonAsLink, ...restBackButtonProps } = backButtonProps;
    const isMobileBrowser = useAppSelector(commonUiStateSlice.selectors.selectIsMobileVersion);
    const LogoComponent = () => <Logo maxW={'140px'} />;

    return (
        <Box
            as={'header'}
            my={{
                base: 3,
                md: 5,
            }}
            {...rest}
        >
            <Container
                maxW={'oldContainerWidth'}
                display={'grid'}
                gridTemplateColumns={{ base: '1fr', xl: 'repeat(3, 1fr)' }}
                margin={'0 auto'}
            >
                <Flex gap={2} alignItems={'center'}>
                    {showBackButton ? (
                        <IconButton
                            variant={'plain'}
                            aria-label={translationData.backButtonLabel}
                            minWidth={0}
                            mr={2}
                            size={'lg'}
                            colorPalette={'gray'}
                            asChild
                            {...restBackButtonProps}
                        >
                            {backButtonAsLink ? (
                                <Link href={href ?? '/'}>
                                    <IconsLinear.ArrowLeft />
                                </Link>
                            ) : (
                                <a href={href ?? '/'}>
                                    <IconsLinear.ArrowLeft />
                                </a>
                            )}
                        </IconButton>
                    ) : null}
                    {infoTextInsteadOfLogoOnMobile ? (
                        <>
                            {!isMobileBrowser ? (
                                <LogoComponent />
                            ) : (
                                <Heading fontSize={'sm'} fontWeight={400} {...headingProps}>
                                    {infoTextInsteadOfLogoOnMobile}
                                </Heading>
                            )}
                        </>
                    ) : (
                        <LogoComponent />
                    )}
                </Flex>
                {children ? (
                    <Box display={'flex'} justifyContent={'center'}>
                        {children}
                    </Box>
                ) : undefined}
            </Container>
        </Box>
    );
};
